module.exports = __webpack_public_path__ + "static/media/alternative-heat.697de16c.png";